module.exports = __webpack_public_path__ + "static/media/f0_1.7fcb9901.png";